<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/newIklient/loginImg.png"
                width="491.09px"
                height="341.98px"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h1 class="mb-4 text-primary">{{$t('changePassword.changePassword')}}</h1>
                  <p>{{$t('resetPassword.hereChange')}}</p>
                </div>
                <form @click.prevent>
                  <vs-input
                    type="password"
                    name="password1"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    ref="password"
                    :label-placeholder="$t('resetPassword.newPassword')"
                    v-model="pwd1"
                    v-validate="'required|min:6'"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password1')"
                  >{{ errors.first('password1') }}</span>
                  <vs-input
                    type="password"
                    name="password2"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    :label-placeholder="$t('resetPassword.newPasswordAgain')"
                    v-model="pwd2"
                    v-validate="'required|confirmed:password'"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password2')"
                  >{{ errors.first('password2') }}</span>
                  <span class="text-danger text-sm">{{this.errorMsg}}</span>
                  <div class="flex flex-wrap justify-between my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                    <!-- <router-link to="#">Forgot Password?</router-link> -->
                    <small>
                      <a
                        href="javascript:void(0)"
                        @click="backToLogin"
                      >{{$t('changePassword.logIn')}}</a>
                    </small>
                  </div>
                  <!-- <vs-button type="border">Registrovat</vs-button> -->
                  <vs-button
                    class="float-right mb-base"
                    @click.prevent="submitChangePassword"
                  >{{$t('resetPassword.changePassword')}}</vs-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const UserCalls = RepositoryFactory.get("user");
import { Validator } from "vee-validate";

const dict = {
  custom: {
    password1: {
      min: "Heslo musí mít alespoň 6 znaků"
    }
  }
};
Validator.localize("cs", dict);
export default {
  data() {
    return {
      pwd1: "",
      pwd2: "",
      email: "",
      token: "",
      errorMsg: ""
    };
  },
  mounted() {},
  created() {
    this.$store.dispatch("resetStore");
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },
  methods: {
    submitChangePassword() {
      this.errorMsg = "";
      this.$vs.loading();
      this.$validator.validateAll().then(result => {
        if (result) {
          UserCalls.setForgottenPassword(this.email, this.pwd1, this.token)
            .then(({ data }) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: this.$t("success"),
                text: this.$t("resetPassword.successfullyChanged"),
                color: "success"
              });
              setTimeout(() => {
                this.$router.push({ name: "pageLogin" });
              }, 1000);
            })
            .catch(err => {
              this.$vs.loading.close();
              this.errorMsg = this.$t("resetPassword.error");
            });
        } else {
          this.$vs.loading.close();
        }
      });
    },
    backToLogin() {
      this.$router.push({ name: "pageLogin" });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
